var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconHeartbeat1 = function SvgIconHeartbeat1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 100 100",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_heartbeat_1_svg2__a",
    x1: 5.66,
    x2: 82.19,
    y1: 70.81,
    y2: 17.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#a80096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#a80096"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.87 87.09h-.29c-1.11-.12-1.99-1.05-2.05-2.23L25.72 30.2l-6.85 25.72c-.29 1-1.23 1.7-2.28 1.7H2.34C1.05 57.62 0 56.57 0 55.28s1.05-2.34 2.34-2.34h12.48l10.25-38.26c.29-1.11 1.35-1.87 2.52-1.76s2.05 1.05 2.11 2.23l2.75 54.72 4.34-16.17c.29-1 1.23-1.7 2.28-1.7h5.8l4.04-14.88a2.38 2.38 0 0 1 2.28-1.76c1.11.06 1.99.82 2.23 1.87l5.16 23.67 5.21-13.83c.35-.94 1.23-1.52 2.23-1.52h31.63c1.29 0 2.34 1.05 2.34 2.34s-1.05 2.34-2.34 2.34H67.6l-7.44 19.74c-.35 1-1.35 1.58-2.34 1.52-1.05-.12-1.93-.82-2.17-1.87L50.9 47.59l-1.99 7.32c-.29 1-1.17 1.76-2.23 1.76h-5.86l-7.73 28.71c-.23 1-1.17 1.7-2.23 1.7Z",
    "data-name": 441042592,
    style: {
      fill: "url(#icon_heartbeat_1_svg2__a)",
      fillRule: "evenodd"
    }
  })));
};
export default SvgIconHeartbeat1;